export type DoctorVideoCard = {
  title: string;
  time: string;
  duration: string;
  img: string;
  subscriberOnly?: boolean;
};

export const DOCTORS_LOUNGE_VIDEOS: DoctorVideoCard[] = [
  {
    title: "打工仔壓力太大應否辭職？",
    time: "12分鐘前",
    duration: "08:24",
    img: "/images/ej-health/video-stress-resign.png",
  },
  {
    title: "如何分辨同事是否有情緒問題？",
    time: "1天前",
    duration: "08:24",
    img: "/images/ej-health/video-coworker-emotion.png",
    subscriberOnly: true,
  },
  {
    title: "哪些工種特別容易出情緒病？",
    time: "1天前",
    duration: "08:24",
    img: "/images/ej-health/video-job-emotion.png",
  },
  {
    title: "中老年情緒問題好難醫治？",
    time: "12分鐘前",
    duration: "08:24",
    img: "/images/ej-health/video-elderly-treatment.png",
    subscriberOnly: true,
  },
  {
    title: "中老年人患情緒病有何症狀?",
    time: "1天前",
    duration: "08:24",
    img: "/images/ej-health/video-elderly-symptoms.png",
  },
  {
    title: "中老年人最常患上哪幾類情緒病？",
    time: "1天前",
    duration: "08:24",
    img: "/images/ej-health/video-elderly-types.png",
  },
  {
    title: "青少年情緒疾病可不可用藥物治療？",
    time: "12分鐘前",
    duration: "08:24",
    img: "/images/ej-health/video-youth-medication.png",
  },
  {
    title: "如何辨別青少年情緒問題症狀？",
    time: "1天前",
    duration: "08:24",
    img: "/images/ej-health/video-youth-symptoms.png",
  },
  {
    title: "如何支援小朋友情緒問題？",
    time: "1天前",
    duration: "08:24",
    img: "/images/ej-health/video-children-support.png",
    subscriberOnly: true,
  },
];
